
import { lighten } from '@material-ui/core/styles/colorManipulator';
import {colorPrimary} from '../../../utils/setting'
export const styles = theme => ({
  titleChart: {
    textTransform: 'capitalize'
  },
  xAxis: {
    color: '#000'
  },
  reCharts: {
    color: colorPrimary
  },
  root: {
    marginTop: theme.spacing(3),
    position: 'relative'
  },
  container: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
    },
    paddingRight: 0,
    paddingLeft: 0,
  },
  labelChart: {
    textAlign: 'center',
    fontSize: '0.89rem',
    lineHeight: 'normal',
    textTransform: 'capitalize'

  },
  countReact: {
      backgroundColor: 'rgba(201, 203, 209, 0.25)',
      width: '80%',
      minWidth: 50,
      minHeight: '3rem',
      fontWeight: 'bold',
      fontSize : '1.78rem',
      [theme.breakpoints.up('md')]: {
        minHeight: '3.56rem',
      },
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2),
  },
  countReactLike : {
    color: '#ffbc5b',
  },
  countReactHeart : {
    color: '#ae76ff',
  },
  countReactFollow : {
    color: '#ff6b5c',
  },
  leftReaction : {
    alignItems: 'center',
    flexDirection: 'column',
    display: 'flex',
    justifyContent: 'center',
    paddingRight: theme.spacing(5),
    paddingLeft: theme.spacing(10),
  },
  rightReaction : {
    overflow: 'auto',
    paddingRight: theme.spacing(10),
    paddingLeft: theme.spacing(5),
    paddingBottom: theme.spacing(1),
  }
});
export const toolbarStyles = theme => ({    
  titleText: {
    fontSize: '1.11rem',
  },
  root: {
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
    boxSizing: 'border-box',
    backgroundColor: 'rgba(41, 47, 72, 0.85)',
    color: '#fff',
    [theme.breakpoints.up('md')]: {
      minHeight: theme.spacing(7)
    },
    [theme.breakpoints.up('sm')]: {
      minHeight: theme.spacing(7)
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#f4f4f4',
    '&:hover': {
      backgroundColor: '#f4f4f4',
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  // inputRoot: {
  //   color: 'inherit',
  //   width: theme.spacing(24),
  //   boxSizing: 'border-box'
  // },
  // inputInput: {
  //   paddingTop: theme.spacing(1),
  //   paddingRight: theme.spacing(2),
  //   paddingBottom: theme.spacing(1),
  //   paddingLeft: theme.spacing(2),
  //   transition: theme.transitions.create('width'),
  //   width: '100%',
  // },
  // highlight:
  //   theme.palette.type === 'light'
  //     ? {
  //         color: theme.palette.secondary.main,
  //         backgroundColor: lighten(theme.palette.secondary.light, 1),
  //       }
  //     : {
  //         color: theme.palette.text.primary,
  //         backgroundColor: theme.palette.secondary.dark,
  //       },
  spacer: {
    flex: '1 1 100%',
    textAlign: 'right',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
    color: '#fff'
  },
  // btnRoot: {   
  //     color: '#263238',
  //     paddingTop: '6px',
  //     paddingBottom: '6px',
  //     paddingLeft: '16px',
  //     paddingRight: '16px',
  //     fontSize: '14px',
  //     justifyContent: 'left',
  //     // width: theme.spacing(24),
  //     width: '100%',
  //     fontWeight: 500,
  //     lineHeight: 1.75,
  //     borderRadius: '4px',
  //     textTransform: 'uppercase',
  //     color: 'rgba(0, 0, 0, 0.87)',
  //     backgroundColor: '#ffffff'
  // },
  // calendarIcon: {
  //     marginRight: theme.spacing(1),
  // },
  });